/**
 * Locale selectors for Redux state
 */

import { select } from 'redux-saga/effects';

/**
 * Selects the locale state from the Redux store
 * @param {Object} state - Redux state
 * @returns {Object} Locale state object
 */
export const selectLocaleState = (state) => state.locale;

/**
 * Selects the current locale code from the Redux store
 * @param {Object} state - Redux state
 * @returns {string|undefined} Current locale code (e.g., 'en', 'de', etc.)
 */
export const selectLocale = (state) => state.locale?.locale;

/**
 * Saga helper: Gets the current locale code within a saga
 * Usage: const locale = yield* getLocale();
 * @returns {Generator} Saga effect that resolves to locale code
 */
export function* getLocale() {
  const locale = yield select(selectLocale);
  return locale;
}
